import { Group, GroupSettings } from '../types/Group';

export const defaultGroupSettings: GroupSettings = {
  dealerNotifications: false,
  salesRepNotifications: false,
};

export const unknownGroup: Group = {
  updating: false,
  groupName: '',
  groupId: '',
  configurators: [],
  settings: defaultGroupSettings,
};
